/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable object-curly-newline */
import './CheckOutCredential.css';

import {
  handleScroll,
  InSeparator,
  InterPoint,
  useDetectScroll,
} from '@saviynt/common';
import {
  AccordionStepper,
  Box,
  Button,
  FooterActionBar,
  Icon,
  InlineMessage,
  Link,
  ModalPageHeader,
} from '@saviynt/design-system';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  handleAccountId,
  handleDateRange,
  handleJustification,
  handleRequestedFor,
  handleRequestor,
} from '../../action/CredentialRequestFormAction';
// TODO: remove mock data after merging and QA testing
import { MockAccountListSingleEndpointKeyFour } from '../../models/MockData/MockAccountList';
import { getAccountListApi } from '../../utilities/api/getDataFromApi';
import AccountSelection from './AccordionContentPanels/AccountSelection/AccountSelection';
import JustificationDetails from './AccordionContentPanels/JustificationDetails/JustificationDetails';
import TimeAccessDuration from './AccordionContentPanels/TimeAccessDuration/TimeAccessDuration';
import AccountListModalIsland from './AccountListModalIsland/AccountListModalIsland';

function CheckOutCredential() {
  const [isCritical, setIsCritical] = useState({
    duration: false,
    justification: false,
  });
  // Accordion expanded booleans
  const [isAccountSelection, setIsAccountSelection] = useState(false);
  const [isExpandedDuration, setIsExpandedDuration] = useState(false);
  const [isExpandedDetail, setIsExpandedDetail] = useState(false);
  // AccountSelection
  const [accountListArray, setAccountListArray] = useState(null);
  const [accountSelection, setAccountSelection] = useState(null);
  const [isAccountListModal, setIsAccountListModal] = useState(false);
  // TimeAccessDuration
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [durationAccordionValue, setDurationAccordionValue] = useState(null);
  // TODO: refactor duration and error handlers to reference the redux store instead of this modalPageFormData state.
  // Modal Form
  const [modalPageFormData, setModalPageFormData] = useState({
    duration: null,
    detail: {
      justification: '',
      ticketNumber: '',
      attachments: [],
    },
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const accordionContentRef = useRef(null);
  const accountListModalContentRef = useRef(null);

  const [cookies] = useCookies(['user_name']);
  const userName = cookies.user_name;

  const checkOutCredentialForm = useSelector(
    (state) => state.credentialRequestForm
  );

  useEffect(() => {
    if (!accountSelection) return;

    dispatch(handleAccountId(accountSelection?.value, 'Account Id success'));
    dispatch(
      handleRequestedFor(accountSelection?.title, 'Requested For success')
    );
  }, [accountSelection]);

  // Scrolling logics section
  const { isScrolled: accordionContentRefIsScrolled } = useDetectScroll(
    null,
    accordionContentRef
  );
  const { isScrolled: accountModalSectionRefIsScrolled } = useDetectScroll(
    null,
    accountListModalContentRef
  );

  // Open Account accordion when list is ready
  useEffect(() => {
    if (accountListArray) setIsAccountSelection(true);
  }, [accountListArray]);

  // Getting relavent info from accounts to send to Radio buttons
  const extractAccountDetails = (accountList) => {
    if (!accountList.result || !accountList.result.accounts) return;

    const { accounts } = accountList.result;
    const extractedDetails = accounts.map((account) => ({
      value: account.accountKey,
      title: account.name,
      description: account.pamAccountType,
    }));

    setAccountListArray(extractedDetails);
  };

  useEffect(() => {
    const shouldUseMockData =
      window.location.href === 'http://localhost:3001/PAM/check-out-credential';

    if (shouldUseMockData) {
      // TODO: remove mock data after merging and QA testing
      console.log('Using mock data on localhost');
      extractAccountDetails(MockAccountListSingleEndpointKeyFour);
    } else {
      // Update the redux requestor on mount
      if (userName) dispatch(handleRequestor(userName, 'Requestor success'));

      // Update the accountListArray on mount
      getAccountListApi()
        .then((response) => {
          extractAccountDetails(response);
        })
        .catch((error) => {
          console.error(
            'An error occurred while fetching the account list:',
            error
          );
        });
    }
  }, [userName]);

  // Classes
  const modalContentClass = classnames('ModalPage');

  // Extracted Check Out Credential page comps
  const subHeadingContent = () => (
    <div className='ModalPage-subHeadingContent'>
      <p className='ModalPage-subHeadingContent-body'>WIN-LA-breakglass</p>
      <InterPoint color='neutralSubtlest' />
      <p className='ModalPage-subHeadingContent-body'>Account</p>
      <InSeparator color='neutralInverse' />
      <p className='ModalPage-subHeadingContent-body'>Vault</p>
    </div>
  );

  const suffixLink = () => (
    <Link
      href='/'
      url='/'
      text='View Schedule'
      prefixIconKind='Calendar'
      target='_self'
      shouldStopPropagation
    />
  );

  const accordionValueWithQuotes = modalPageFormData.detail.justification
    ? `"${modalPageFormData.detail.justification}"`
    : null;

  // Event handlers
  const closeHandler = () => {
    history.goBack();
  };

  // Close Account Accordion on selection
  useEffect(() => {
    if (accountSelection) {
      setIsAccountSelection(false);
      setIsExpandedDuration(true);
    }
  }, [accountSelection]);

  const handleDurationSubmit = (value) => {
    if (value === null) {
      setModalPageFormData((prevState) => ({
        ...prevState,
        duration: value,
      }));
    } else {
      // Close duration
      // TODO: bring back when branch task: TimePicker is done.
      setIsExpandedDuration(false);
      // Open next stepper
      setIsExpandedDetail(true);
      setModalPageFormData((prevState) => ({
        ...prevState,
        duration: value,
      }));
    }
  };

  const handleDetailsSubmit = (value) => {
    setModalPageFormData((prevState) => ({
      ...prevState,
      detail: {
        justification: value.justification,
        ticketNumber: value.ticketNumber,
        attachments: value.attachments,
      },
    }));
  };

  useEffect(() => {
    if (modalPageFormData.duration)
      setIsCritical((otherReq) => ({ ...otherReq, duration: false }));
  }, [modalPageFormData]);

  const handleModalSubmit = () => {
    const hasDuration = modalPageFormData.duration;
    const hasJustification = modalPageFormData.detail.justification;

    if (hasDuration)
      setIsCritical((otherReq) => ({ ...otherReq, duration: false }));

    if (!hasDuration) {
      setIsExpandedDuration(true);

      setIsCritical((otherReq) => ({
        ...otherReq,
        duration: true,
      }));

      return null;
    }

    if (!hasJustification) {
      setIsExpandedDetail(true);

      setIsCritical((otherReq) => ({
        ...otherReq,
        justification: true,
      }));

      return null;
    }

    return null;
  };

  return (
    <Box className='ModalPage-master' data-testid='check-out-credential'>
      <ModalPageHeader
        title='Check Out Credential'
        subHeadingContent={subHeadingContent()}
        closeHandler={() => closeHandler()}
        className='ModalPage-header'
      />
      <section className={modalContentClass} ref={accordionContentRef}>
        <Box className='ModalPage-scrollingArea'>
          <AccountListModalIsland
            accountListArray={accountListArray}
            accountListModalContentRef={accountListModalContentRef}
            sectionRefIsScrolled={accountModalSectionRefIsScrolled}
            accountSelection={accountSelection}
            setAccountSelection={setAccountSelection}
            isAccountListModal={isAccountListModal}
            setIsAccountListModal={setIsAccountListModal}
          />
          <AccordionStepper
            isExpanded={isAccountSelection}
            setIsExpanded={setIsAccountSelection}
            prefixIconKind='account'
            headerText='Which account do you need?'
            primarySupportingText='Select an account or create a new one'
            accordionValue={checkOutCredentialForm?.requestedfor}>
            <AccountSelection
              accountListArray={accountListArray}
              accountSelection={accountSelection}
              setAccountSelection={setAccountSelection}
              setIsAccountListModal={setIsAccountListModal}
            />
          </AccordionStepper>
          {accountSelection && (
            <AccordionStepper
              isCritical={isCritical.duration}
              isExpanded={isExpandedDuration}
              setIsExpanded={setIsExpandedDuration}
              prefixIconKind='time'
              headerText='When do you need access?'
              primarySupportingText='Select a timeframe'
              accordionValue={durationAccordionValue}
              suffixLink={suffixLink()}
              criticalMessage={
                isCritical.duration && (
                  <InlineMessage
                    text='Duration must be a minimum of {##} {Hours/Days} and a maximum of {##} {Hours/Days}.'
                    colorTheme='critical'
                    size='small'
                    leftIcon={
                      <Icon kind='AlertCritical' color='critical-700' />
                    }
                  />
                )
              }>
              <TimeAccessDuration
                setAccordionValue={setDurationAccordionValue}
                duration={modalPageFormData.duration}
                setDuration={(value) => handleDurationSubmit(value)}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />
            </AccordionStepper>
          )}
          {durationAccordionValue && (
            <AccordionStepper
              isExpanded={isExpandedDetail}
              setIsExpanded={setIsExpandedDetail}
              prefixIconKind='document'
              headerText='Do you have other details to include?'
              primarySupportingText='Provide optional comments, attachments, and ticket number'
              accordionValue={accordionValueWithQuotes}>
              <JustificationDetails
                isCritical={isCritical.justification}
                setIsCritical={setIsCritical}
                detailsObj={modalPageFormData.detail}
                setDetails={(obj) => handleDetailsSubmit(obj)}
              />
            </AccordionStepper>
          )}
        </Box>
      </section>
      {/* TODO: replace with new handle scroll hook from common. */}
      <FooterActionBar
        className='ModalPage-footer'
        isScrolled={accordionContentRefIsScrolled}>
        <Button
          kind={
            modalPageFormData.duration && modalPageFormData.detail.justification
              ? 'filled'
              : 'outlined'
          }
          onClick={() => {
            handleModalSubmit();
          }}
          rightIcon={<Icon kind='arrowRight' />}>
          Submit
        </Button>
      </FooterActionBar>
    </Box>
  );
}

export default CheckOutCredential;
